import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import ShiftSchedule from '../../types/api/shift-schedule'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const shiftSchedulesApi = createApi({
    reducerPath: 'shiftSchedulesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['ShiftSchedules'],
    endpoints: builder => ({
        getShiftSchedules: builder.query<Strapi<ShiftSchedule>, EndpointQueryParameters | void>({
            query: getQuery('/shift-schedules'),
            providesTags: ['ShiftSchedules'],
        }),
        createShiftSchedule: builder.mutation<
            StrapiSingle<ShiftSchedule>,
            StrapiCreate<ShiftSchedule>
        >({
            query: body => ({
                url: '/shift-schedules',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ShiftSchedules'],
        }),
        updateShiftSchedule: builder.mutation<
            StrapiSingle<ShiftSchedule>,
            StrapiUpdate<ShiftSchedule>
        >({
            query: ({ docId, body }) => ({
                url: `/shift-schedules/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['ShiftSchedules'],
        }),
        deleteShiftSchedule: builder.mutation<void, string>({
            query: docId => ({ url: `/shift-schedules/${docId}`, method: 'DELETE' }),
            invalidatesTags: ['ShiftSchedules'],
        }),
    }),
})

export const {
    useGetShiftSchedulesQuery,
    useCreateShiftScheduleMutation,
    useUpdateShiftScheduleMutation,
    useDeleteShiftScheduleMutation,
} = shiftSchedulesApi
